import { Injectable } from "@angular/core";
import { ConfigService } from "b2b-ecommerce-lib";
import { Environment } from "../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AppConfigService implements ConfigService {
  constructor() {}
  getItemsUrl(): string {
    return Environment.CONFIG.itemsUrl;
  }
  getAccessesUrl(): string {
    return Environment.CONFIG.accessesUrl;
  }
  getFilesUrl(): string {
    return Environment.CONFIG.filesUrl;
  }
  getAddressesUrl(): string {
    return Environment.CONFIG.addressesUrl;
  }
  getPurchasesUrl(): string {
    return Environment.CONFIG.purchasesUrl;
  }
  getReviewsUrl(): string {
    return Environment.CONFIG.reviewsUrl;
  }
  getAmazonUrl(): string {
    return Environment.CONFIG.amazonUrl;
  }
}
